import { T } from '../customer/customers.theme';

/**
 * The three marks the stock screen needs that the customers book does not.
 *
 * Same 24px grid and same stroke weight as CustomersUI, so they sit beside
 * those icons without looking borrowed.
 */

const base = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

/** Stock coming in. */
export const ArrowInIcon = ({ size = 15, width = 2.6 }) => (
  <svg {...base(size)} strokeWidth={width}>
    <path d="M12 5v13M6 12.5l6 6 6-6" />
  </svg>
);

/** Stock going out. */
export const ArrowOutIcon = ({ size = 15, width = 2.6 }) => (
  <svg {...base(size)} strokeWidth={width}>
    <path d="M12 19V6M6 11.5l6-6 6 6" />
  </svg>
);

export const BoxIcon = ({ size = 24, width = 1.7 }) => (
  <svg {...base(size)} strokeWidth={width}>
    <path d="M21 8L12 3 3 8v8l9 5 9-5z" />
    <path d="M3 8l9 5 9-5M12 13v8" />
  </svg>
);

/**
 * The round arrow that heads every movement, and the two colours the whole
 * screen is read by: green for what came in, brand for what was used, red for
 * what was thrown away.
 */
export function movementTone(movement) {
  if (!movement) return { ink: T.ink, tint: T.sunk, border: T.border };
  if (movement.status === 'canceled') {
    return { ink: T.inkFaint, tint: T.shade, border: T.border, solid: T.inkFaint };
  }
  if (movement.type === 'in') {
    return { ink: '#15803D', tint: T.paidTint, border: '#BBE7CC', solid: T.paid };
  }
  if (movement.reason === 'Waste') {
    return { ink: T.danger, tint: T.dangerTint, border: T.dangerBorder, solid: T.danger };
  }
  return { ink: T.brandInk, tint: T.selectedBg, border: T.selectedBorder, solid: T.brand };
}

export function MovementArrow({ movement, size = 32 }) {
  const tone = movementTone(movement);
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: T.radiusPill,
        background: tone.solid || T.inkFaint,
        color: T.surface,
      }}
    >
      {movement?.type === 'in' ? <ArrowInIcon /> : <ArrowOutIcon />}
    </span>
  );
}
